import { Toast } from "vant";
import { Dialog } from "vant";
import service from './axios';
import { isWeChat } from '@/utils/wx';
import { getWxCodeByOauth } from '@/utils/next.js';
const request = (config) => {
    return new Promise((resolve, reject) => {
        service.request(config).then(res => {
            resolve(res.data);
        }, err => {
            switch (err?.code) {
                case 'Unauthorized':
                    // token失效
                    if (isWeChat()) {
                        Dialog.alert({
                            title: '提示',
                            message: '您还未登录或登录已过期，请重新登录'
                        }).then(() => {
                            // store.dispatch('user/resetToken').then(() => {
                            //   location.reload()
                            // })
                            if (sessionStorage.getItem('yc_token')) {
                                Toast(err.msg);
                                return;
                            }
                            localStorage.clear();
                            sessionStorage.clear();
                            // Bus.$emit('Unauthorized')
                            const callbackUrl = `${window.location.pathname}${window.location.search}`;
                            debugger;
                            getWxCodeByOauth(callbackUrl);
                        });
                    }
                    break;
                default:
                    Toast(err.msg);
                    break;
            }
            reject(err);
        });
    });
};
export default request;
